import { useTranslation } from "react-i18next";
import EquipmentsGrid from "./EquipmentsGrid";
import { NavLink } from "react-router-dom";


export default function EquipmentsMenu({onClose}:{onClose: () => void}) {
  const { t } = useTranslation();
  return (
      <>
        <div className="flex flex-row items-center px-6">
          <NavLink to={"/data/equipment"} onClick={onClose}><div className="text-base font-semibold flex h-14 items-center">{t("equipment")}</div></NavLink>
        </div>
        <EquipmentsGrid onClose={onClose}/>
      </>
  )
} 